import { createAsyncThunk } from "@reduxjs/toolkit";
import { get } from "../../Services/ApiBase";
import { API_ENDPOINTS } from "../../Services/ApiEndPoints";
import { getApiErrorMessage } from "../../utils/apiErrorMessage";

/**
 * Fetch all issues data. Optional params: { search } for keyword search when API supports it.
 */
export const fetchIssuesData = createAsyncThunk(
  "issues/fetchData",
  async (params = {}, { rejectWithValue }) => {
    try {
      const query = {};
      if (params.search != null && String(params.search).trim() !== "") {
        query.search = String(params.search).trim();
      }
      const response = await get(API_ENDPOINTS.ISSUES.GET_ALL, query);
      return response.data;
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error, "Failed to fetch issues data"));
    }
  }
);

/**
 * Fetch issue by ID
 */
export const fetchIssueById = createAsyncThunk(
  "issues/fetchById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await get(API_ENDPOINTS.ISSUES.GET_BY_ID(id));
      return response.data;
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error, "Failed to fetch issue data"));
    }
  }
);
